export const primepayBaseUrl = "/primepay/router";
